import { render } from "./UserSelectModal.vue?vue&type=template&id=f23cf2ca"
import script from "./UserSelectModal.vue?vue&type=script&lang=js"
export * from "./UserSelectModal.vue?vue&type=script&lang=js"
script.render = render

export default script